import React, { useEffect, useState } from "react";
import { SideMenuWrap } from "./components";
const SideMenuContext = React.createContext();
const useSideMenu = () => {
  const context = React.useContext(SideMenuContext);
  if (context === undefined) {
    throw new Error("Context error");
  }
  return context;
};
const SideMenuProvider = ({ children }) => {
  const [open, setOpen] = useState(null);

  useEffect(() => {
    const body = document.querySelectorAll("body");
    body.length &&
      body.forEach &&
      body.forEach((x) => (x.style.overflowY = open ? "hidden" : ""));
  }, [open]);

  return (
    <SideMenuContext.Provider
      value={{
        open,
        setOpen,
      }}
    >
      <SideMenuWrap />
      {children}
    </SideMenuContext.Provider>
  );
};

export { SideMenuProvider, useSideMenu };
